import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Lock, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username: u, password: p });
      localStorage.setItem("torvi_admin_token", data.token);
      toast.success("Bienvenido al panel");
      navigate("/admin");
    } catch {
      toast.error("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-16 hero-gradient" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center">
            <Lock size={18} />
          </div>
          <div>
            <div className="font-heading font-black text-2xl">Panel de Administración</div>
            <div className="text-xs text-slate-500">Acceso solo para Torvi Team</div>
          </div>
        </div>

        <label className="block text-xs uppercase tracking-widest font-bold text-slate-600 mb-1.5">Usuario</label>
        <input
          value={u} onChange={(e) => setU(e.target.value)}
          data-testid="admin-username-input"
          className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9]/30 outline-none mb-4"
          placeholder="admin"
          autoComplete="username"
        />
        <label className="block text-xs uppercase tracking-widest font-bold text-slate-600 mb-1.5">Contraseña</label>
        <input
          type="password" value={p} onChange={(e) => setP(e.target.value)}
          data-testid="admin-password-input"
          className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9]/30 outline-none mb-6"
          placeholder="••••••••"
          autoComplete="current-password"
        />
        <button type="submit" disabled={loading} className="w-full btn-primary inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-submit">
          {loading ? <><Loader2 size={16} className="animate-spin" /> Entrando...</> : <><Sparkles size={16} /> Ingresar</>}
        </button>
      </form>
    </div>
  );
}
